import { render, staticRenderFns } from "./fb.vue?vue&type=template&id=06e1343e&scoped=true"
import script from "./fb.vue?vue&type=script&lang=js"
export * from "./fb.vue?vue&type=script&lang=js"
import style0 from "./fb.vue?vue&type=style&index=0&id=06e1343e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e1343e",
  null
  
)

export default component.exports